import axios from 'axios';

export const signIn = (userId, email) => {
  return {
    type: 'SIGN_IN',
    payload: {
      userId: userId,
      email: email,
    },
  };
};

export const signOut = () => {
  return {
    type: 'SIGN_OUT',
  };
};

export const createTask =
  (title, date, status, duedate, description, todos) =>
  async (dispatch, getState) => {
    try {
      dispatch({ type: 'CREATE_TASK' });

      const { userId } = getState().auth;
      const response = await axios.post('/api/tasks', {
        title,
        date,
        status,
        duedate,
        description,
        todos,
        userId,
      });

      dispatch({
        type: 'CREATED_TASK',
        payload: { data: response.data, userId: userId },
      });
    } catch (err) {
      console.log(err);
      dispatch({
        type: 'CREATE_TASK_FAILED',
        payload: {
          message:
            'Something went wrong. Could not create a new project. Please try again.',
        },
      });
    }
  };

export const fetchTasks = () => async (dispatch, getState) => {
  try {
    dispatch({ type: 'REQUEST_TASKS' });

    const { userId } = getState().auth;
    const response = await axios.get('/api/tasks');

    dispatch({
      type: 'RECEIVED_TASKS',
      payload: { data: response.data, userId: userId },
    });
  } catch (err) {
    console.log(err);
    dispatch({
      type: 'RECEIVE_TASKS_FAILED',
      payload: {
        message: 'Something went wrong. Could not get data. Please try again.',
      },
    });
  }
};

export const fetchTask = (id) => async (dispatch) => {
  try {
    dispatch({ type: 'REQUEST_TASK' });

    const response = await axios.get(`/api/tasks/${id}`);
    dispatch({ type: 'RECEIVE_TASK', payload: response.data });
  } catch (err) {
    console.log(err);
    dispatch({
      type: 'RECEIVE_TASK_FAILED',
      payload: {
        message: 'Something went wrong. Could not get data. Please try again.',
      },
    });
  }
};

export const updateTask =
  (id, title, date, status, duedate, description, todos) =>
  async (dispatch, getState) => {
    try {
      dispatch({ type: 'UPDATE_TASK' });

      const { userId } = getState().auth;
      const response = await axios.patch(`/api/tasks/${id}`, {
        title,
        date,
        status,
        duedate,
        description,
        todos,
      });

      dispatch({
        type: 'UPDATED_TASK',
        payload: { data: response.data, userId: userId },
      });
    } catch (err) {
      console.log(err);
      dispatch({
        type: 'UPDATE_TASK_FAILED',
        payload: {
          message:
            'Something went wrong. Could not update data. Please try again.',
        },
      });
    }
  };

export const deleteTask = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: 'DELETE_TASK' });

    const { userId } = getState().auth;

    const response = await axios.delete(`/api/tasks/${id}`);
    dispatch({
      type: 'DELETED_TASK',
      payload: { data: response.data, userId: userId },
    });
  } catch (err) {
    console.log(err);
    dispatch({
      type: 'DELETE_TASK_FAILED',
      payload: {
        message:
          'Something went wrong. Could not delete a project. Please try again.',
      },
    });
  }
};
